import { defineComponent as a } from "vue";
import { render as s } from "./index345.js";
var p = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(p || {});
let f = a({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: i, attrs: o }) {
  return () => {
    var r;
    let { features: t, ...d } = e, n = { "aria-hidden": (t & 2) === 2 ? !0 : (r = d["aria-hidden"]) != null ? r : void 0, hidden: (t & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(t & 4) === 4 && (t & 2) !== 2 && { display: "none" } } };
    return s({ ourProps: n, theirProps: d, slot: {}, attrs: o, slots: i, name: "Hidden" });
  };
} });
export {
  p as Features,
  f as Hidden
};
